import * as Models from "../.";
export interface ICustomerAction {
  name: string;
  description: string;
  eventDisplayName: string;
  sectionName: string;
  sectionDisplayOrder: number;
  actionHtmlId: string;
  requiresActiveCustomer: boolean;
  enabled: boolean;
  roles: Array<Models.RoleModel.RoleModel>;
}

export class CustomerAction implements ICustomerAction {
  name: string;
  description: string;
  eventDisplayName: string;
  sectionName: string;
  sectionDisplayOrder: number;
  displayOrder: number;
  actionHtmlId: string;
  requiresActiveCustomer: boolean;
  enabled: boolean;
  roles: Array<Models.RoleModel.RoleModel>;
}
